import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import React, { useContext } from "react";
import { Formik } from "formik";
import * as Yup from 'yup';
import { BrandContext } from "../../../contexts/BrandContext";
import { cLog, cWarn } from "../CustomLogger";
import BasicInputField from "../form/BasicInputField";
import axios from "../../../utils/axios";


export default function CancelBookingDialogue(props){

    const brandContext = useContext(BrandContext);
    const {
        textContent:{
            cancelBookingButton='',
            widget_cancelButton:cancelButton='',
            confirmCancellationButtonText=''
        }
    } = brandContext;

    const {
        showDialogue,
        bookingId,
        updateCall,
        setShowDialogue,
    } = props;
    
    
    
    
    const validationSchema = Yup.object().shape({
        notes: Yup.string()
            .required('Required'),
    });

    const formFields = {
        'notes': {
            'label': 'cancellationReasonFormLabel',
            'type':'textarea',
            'default':''
        },
    }

    const initialValues = () => {
        const fields = formFields;

        const initialValues = {};
        const keys = Object.keys(fields);
        const values = Object.values(fields);
        for (let i = 0; i < keys.length; i += 1) {
            initialValues[keys[i]] = ('default' in values[i] ? values[i].default : '');
        }
        return initialValues;
    }
    
    const doShow = showDialogue === true 
    

    return (
        <Dialog open={doShow} onClose={()=>{setShowDialogue(false)}}>
            <DialogTitle>{cancelBookingButton}</DialogTitle>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    cLog(values);
                    const apiPath = `${process.env.REACT_APP_API_URL}/staffbookingcancel/${bookingId}`;
                    axios.post(apiPath,values,{
                        timeout: 300000,
                        withCredentials:true
                    }).then(() => {
                       
                        setShowDialogue(false);
                        if(updateCall){
                            updateCall(bookingId,{isCancelled:true});
                        }
                    }).catch(err => {
                       // console.log('caught the error');
                       cWarn(err);
                    });
                }}
            >
                {props => (
                    <form onSubmit={props.handleSubmit}>
                        <DialogContent>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                    <BasicInputField sx={{width:400}}  formik={props} formFields={formFields} fieldName="notes" variant='outlined'/>
                                </Grid>
                            </Grid>
                            
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={()=>{setShowDialogue(false)}}>{cancelButton}</Button>
                            <Button type="submit">{confirmCancellationButtonText}</Button>
                        </DialogActions>
                    </form>                                
                )}
            </Formik>
        </Dialog>
    );

}
